import React, { ReactNode } from 'react';
import { Col } from 'antd';
import cx from 'classnames';

import styles from '../HistoryCard.module.less';

type Props = {
  title?: string | ReactNode;
  emptyText?: string;
  value?: null | string | React.ReactNode;
  dataId?: string;
};

const isRenderableValue = (value: Props['value']): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return true;
  }

  if (React.isValidElement(value)) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.every(isRenderableValue);
  }

  return false;
};

export default function HistoryField(props: Props) {
  const { title, value, emptyText = 'No data', dataId = '' } = props;
  const safeValue = isRenderableValue(value) ? value : '';
  const normalizedValue =
    typeof safeValue === 'string' && safeValue.trim() === ''
      ? undefined
      : safeValue;
  const isValueSpecified =
    !!normalizedValue &&
    !(Array.isArray(normalizedValue) && normalizedValue.length === 0);

  return (
    <Col xs={24} md={12}>
      {title && <div className="title">{title}:</div>}

      <div>
        <span
          className={cx({ [styles.noDataMessage]: !isValueSpecified })}
          data-id={dataId}
        >
          {isValueSpecified ? normalizedValue : emptyText}
        </span>
      </div>
    </Col>
  );
}
